/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gbp_Connect_HintInputs */

const cs_integrations_gbp_connect_hint = /** @type {(inputs: Integrations_Gbp_Connect_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojte Google Business Profile přes OAuth, až ho správce zapne.`)
};

const en_integrations_gbp_connect_hint = /** @type {(inputs: Integrations_Gbp_Connect_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google Business Profile via OAuth after an administrator enables it.`)
};

/**
* | output |
* | --- |
* | "Connect Google Business Profile via OAuth after an administrator enables it." |
*
* @param {Integrations_Gbp_Connect_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gbp_connect_hint = /** @type {((inputs?: Integrations_Gbp_Connect_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gbp_Connect_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gbp_connect_hint(inputs)
	return cs_integrations_gbp_connect_hint(inputs)
});